import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ICON, PERIOD, TITLE } from '../../../../../../../constants/shared/CommonConstants';
import './TrcCard.scss';
import { generateReactKey } from '../../../../../../../utils/shared/commonUtils';

const { PAUSED } = ICON;

const TrcCard = ({ isEmpty, isPaused, period, result, summeryLabel }) => {
    const { interp, bookTitle, cardType, cell, cardStats } = result;

    return isEmpty || isPaused ? (
        <section className="panel empty">
            <h3 className="period">{period === PERIOD.SUMMER ? summeryLabel : period}</h3>
            {isPaused && (
                <div className="data-cell trc-summary-card-cell-paused">
                    {PAUSED}
                    Paused
                </div>
            )}
        </section>
    ) : (
        <section className={`panel ${interp}`}>
            <h3 className="period">{period === PERIOD.SUMMER ? summeryLabel : period}</h3>
            {cell}
            <h4 className="book-title">{bookTitle}</h4>
            <div className="stats">
                {Object.keys(cardStats).map(status => (
                    <Fragment key={generateReactKey(status)}>
                        <p className="card-status">{status}</p>
                        <p className="card-status value">{cardStats[status]}</p>
                    </Fragment>
                ))}
            </div>
            <div className="card-type">{cardType}</div>
        </section>
    );
};

TrcCard.defaultProps = {
    period: '',
    result: {},
    isEmpty: false,
    isPaused: false,
    summeryLabel: TITLE.SUMMER_TITLE,
};

TrcCard.propTypes = {
    period: PropTypes.string,
    result: PropTypes.object,
    isEmpty: PropTypes.bool,
    isPaused: PropTypes.bool,
    summeryLabel: PropTypes.string,
};

export default TrcCard;
